var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-dialog',{ref:"form_login_alter_password",attrs:{"title":"修改密码","data":_vm.LoginAlterPasswordDialog.data,"visible":_vm.visibleSync,"columns":_vm.LoginAlterPasswordDialog.columns},on:{"update:visible":function($event){_vm.visibleSync=$event},"confirm":_vm.SavePassword}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37eee882","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginAlterPassword.vue
// module id = null
// module chunks = 